import { logger } from '@fiverr-private/perseus';
import { gofor } from '@fiverr-private/futile';

export const getFormData = ({ requestContext, pathfinderWrapper }) => {
    const { params } = requestContext;
    const { username, slug } = params;

    const url = pathfinderWrapper.pathfinder('new_custom_order_request_form', { seller: username, gig: slug});

    return gofor(url)
        .then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                const error = new Error('Failed to fetch custom order data');
                logger.error(
                    error,
                    {
                        responseStatus: response.status,
                        ajaxUrl: url
                    }
                );

                throw error;
            }
        });
};
